import { atom, getDefaultStore } from 'jotai'
import { atomWithStorage, RESET } from 'jotai/utils'

const store = getDefaultStore()

const _bypassAdminAtom = atomWithStorage('bypass-admin', false)
export const bypassAdminAtom = atom(
  get => get(_bypassAdminAtom),
  (_, set, value) => {
    set(_bypassAdminAtom, value ? true : RESET)
  },
)

/**
 * Get the current bypass admin setting
 */
export function bypassAdmin(): boolean
/**
 * Set the bypass admin setting
 *
 * @returns The new bypass admin setting
 */
export function bypassAdmin(value: boolean): boolean
// Implementation
export function bypassAdmin(value?: boolean): boolean {
  // Set
  if (value != null) {
    store.set(bypassAdminAtom, value)
  }

  return store.get(bypassAdminAtom)
}
